import React from 'react';
import HeroSection from './HeroSection';
import Footer from './Footer';
import Skills from './Skills';

function Home() {

  return (
    <>
      <HeroSection />
      <Skills/>
      <Footer/>
    </>
    
  );
}

export default Home